import Link from 'next/link';
import Image from 'next/image';

/* Store */
import { useNavigationStorePrePendMenuByPath } from '@store/client/store.navigation';

/* Types */
import { ISku } from 'src/constants/nav';

/* Styles */
import styles from '../topnavitems.module.scss';

type TVariant = 'standard' | 'secondNav';

type SkuCategoryItemProps = {
  sku: ISku;
  variant?: TVariant;
  short?: boolean;
};

type SkuCategoryItemsProps = {
  skus: ISku[];
  variant?: TVariant;
  short?: boolean;
};

export const SkuCategoryItem = ({ sku, short = false, variant = 'standard' }: SkuCategoryItemProps) => {
  const className = variant === 'secondNav' ? styles.skuItemSecondNav : styles.skuItem;
  const seoName = sku.seoName || sku.seo_name;

  /* Stores/Selectors */
  const prePendMenuByPath = useNavigationStorePrePendMenuByPath();

  /* Constants */
  const content = (
    <>
      {variant === 'secondNav' && sku.image && (
        <div className={styles.imageContainer}>
          <Image alt={sku.name} src={sku.image} width={24} height={24} />
        </div>
      )}
      {short ? sku.shortName || sku.name : sku.name}
    </>
  );

  const link = (() => (
    <Link data-testid="navigation-menu-sku-link" className={styles.skuLink} prefetch={false} href={`${prePendMenuByPath}/${seoName}`}>
      {content}
    </Link>
  ))();

  if (!seoName) return null;

  return (
    <span className={className}>
      {link}
      {variant === 'secondNav' && sku.popular && <div className={styles.popularChip}>Popular</div>}
    </span>
  );
};

const SkuCategoryItems = (propAttrs: SkuCategoryItemsProps) => {
  const { skus } = propAttrs;
  const skuList = skus.map((sku: ISku) => <SkuCategoryItem {...propAttrs} key={sku.id} sku={sku} />);

  return <>{skuList}</>;
};

export default SkuCategoryItems;
